<template>
  <div class="h-[90vh] max-h-[90vh] overflow-y-auto">
    <div class="flex flex-col py-2 px-3" v-for="item in 5" :key="item">
      <div class="flex gap-5">
        <div class="w-[100px] h-[100px] bg-gray-400"></div>

        <div class="flex flex-1 flex-col text-sm gap-3 text-gray-900">
          <div class="bg-gray-400 p-1 w-full h-4 rounded-sm"></div>
          <div class="bg-gray-400 p-1 w-full h-4 rounded-sm"></div>
          <div class="flex items-end justify-end pt-3">
            <div class="bg-gray-400 p-1 w-24 h-6"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
